import { render, staticRenderFns } from "./choosePop.vue?vue&type=template&id=6eb075b9&scoped=true"
import script from "./choosePop.vue?vue&type=script&lang=js"
export * from "./choosePop.vue?vue&type=script&lang=js"
import style0 from "./choosePop.vue?vue&type=style&index=0&id=6eb075b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb075b9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConjoinedGoodsBasicCard: require('/drone/src/components/ConjoinedGoods/basicCard.vue').default})
